import { birthDateConvertion } from './birthDateConvertion';

type Converter = {
  name: string;
  /** Во второй параметр-объект сможем добавлять другие исключения, не только для девкода
   * Подразумевается что все функции конвертации вызываются с двумя параметрами
   */
  convertionFunction: (value: string, options: { isDevcode: boolean }) => string;
};

/**
 * массив с ф - ми конвертации данных формы для определенных полей
 */
export const converters: Converter[] = [
  { name: 'phone', convertionFunction: (value: string) => value.replace('+', '') },
  {
    name: 'birthday',
    convertionFunction: (value: string, { isDevcode }) => birthDateConvertion(value, isDevcode)
  },
  {
    name: 'nationality',
    convertionFunction: (value: string) => value.toUpperCase()
  }
];
